import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputCheckbox from '../../commons/form/InputCheckBox'
import SignTypeModalPage from '../../../containers/masters/signType/SignTypeModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class SignTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        name: null,
        description: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchSignTypeList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchSignTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchSignTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  searchSignTypeList () {
    this.props.actions.fetchSignTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  render () {
    const {
      t, signTypeList, pagesCount, signTypeCount, filter,
      filter: { page },
      actions: { openSignTypeModal, fetchSignTypeList }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'signatureTypeMasterPage' })
    const tKey = 'MASTERS.SIGNATURE_TYPE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)

    return (
      <div id="signTypeMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openSignTypeModal(null)}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('code') }}>
                      {t(`${tKey}CODE`)}
                      <i className={this.getSortIcon('code')} />
                    </th>
                    <th onClick={() => { this.changeOrder('name') }}>
                      {t(`${tKey}NAME`)}
                      <i className={this.getSortIcon('name')} />
                    </th>
                    <th className='actions' onClick={() => { this.changeOrder('available') }}>
                      {t(`${tKey}AVAILABLE`)}
                      <i className={this.getSortIcon('available')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {signTypeList && signTypeList.map((signType, idx) => (
                    <tr key={idx}>
                      <td>{signType.code}</td>
                      <td>{signType.name}</td>
                      <td className='actions'>{
                        <Field
                          component={InputCheckbox}
                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                          name={'selectedCheck_' + signType.signTypeId}
                          checked = {signType.available}
                          disabled= {true}
                          id={'selectedCheck_' + signType.signTypeId}
                        />}
                      </td>
                      <td className='actions'>
                        <div>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <a className='_Btn accept stk o-icn' onClick={() => openSignTypeModal(signType)}>
                              <i className="iDocIcon-edit" />
                            </a>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {(signTypeList === null || signTypeList === undefined || signTypeList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_finance"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={signTypeCount}
                    onSelectAction={(value) => fetchSignTypeList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <SignTypeModalPage/>
        <Col sm={12} className="col-row  section-users-body">

        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'signTypeMaster'
})(SignTypeMaster)
